import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class CustomerStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}
